import { createFileRoute } from '@tanstack/react-router'

import { ReportPage } from '@/components/reports/report-page'
import { DeliveryTab } from '@/components/reports/delivery-tab'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute('/_app/_authed/_sidebar/reports/delivery')(
    {
        component: DeliveryReportPage,
    },
)

function DeliveryReportPage() {
    return (
        <ReportPage title={m.report_page_title_delivery()}>
            <DeliveryTab />
        </ReportPage>
    )
}
